import { render, staticRenderFns } from "./codigosBloqueados.vue?vue&type=template&id=ce8f3300"
import script from "./codigosBloqueados.vue?vue&type=script&lang=js"
export * from "./codigosBloqueados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports